module.exports = __webpack_public_path__ + "abcb79d6d0048db3dbfb336d221e6100.png";